import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  hideRankProgressionDetail,
  showRankProgressionDetail,
} from '/redux/action/coach.action';
import {
  nextRankIdById,
  rankProgressionDetailVisibleByCoachAndRankIds,
} from '/redux/selector/coach.selector';
import {fromProps, withProps} from '/util/selector.util';

import ProgressTarget from './ProgressTarget';

export default connect(
  createStructuredSelector({
    rankId: nextRankIdById,
    detailVisible: withProps({
      rankId: nextRankIdById,
      targetName: fromProps(get('name')),
    })(rankProgressionDetailVisibleByCoachAndRankIds),
  }),
  dispatch => ({
    showDetail: ({coachId, rankId, targetName}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(showRankProgressionDetail({coachId, rankId, targetName})),
    hideDetail: ({coachId, rankId, targetName}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(hideRankProgressionDetail({coachId, rankId, targetName})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    showDetail: () =>
      dispatchProps.showDetail({
        coachId: ownProps.coachId,
        rankId: stateProps.rankId,
        targetName: ownProps.name,
      }),
    hideDetail: () =>
      dispatchProps.hideDetail({
        coachId: ownProps.coachId,
        rankId: stateProps.rankId,
        targetName: ownProps.name,
      }),
  }),
)(ProgressTarget);
